module.exports = __webpack_public_path__ + "static/media/chart_empty-pl.b4385e40.png";